export default "__VITE_ASSET__316da7dd__"